<template>
  <div class="container-fluid">
    <tax-form
      :loading="loading"
      :taxData="tax"
      :formErrors="formErrors"
      @taxSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultTax from "../defaultTax";
import TaxForm from "../partials/TaxForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    TaxForm,
  },

  mixins: [alertLeave],

  data() {
    const tax = cloneDeep(defaultTax);
    if (this.$currentUserIsLevelOrganization()) {
      tax.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      tax,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    async handleSubmit(tax) {
      this.loading = true;

      const taxData = cloneDeep(tax);
      delete taxData.id;

      try {
        await this.$store.dispatch("taxes/add", taxData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAX_ADDED"),
        });
        const tax = await this.$store.getters["taxes/tax"];
        this.$emit("onViewTax", tax, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
